import * as React from 'react';
import { ActionPlanRiskConsequence, ActionPlanRiskLikelihood } from '../../../amorg-common';
import { Button } from '../../../designSystem/button/Button';
import { Flex } from '../../../designSystem/compositeComponents/FlexHelpers';
import { DetailedRiskAssessmentEvaluator } from '../../../designSystem/graphs/DetailedRiskAssessmentEvaluator';
import { Modal } from '../../../designSystem/Modal';

type DetailedRiskAssessmentModalButtonProps = {
    likelihood:ActionPlanRiskLikelihood,
    consequence: ActionPlanRiskConsequence,
    onUpdate: (consequence: ActionPlanRiskConsequence, likelihood: ActionPlanRiskLikelihood) => void,
}
export function DetailedRiskAssessmentModalButton(props:DetailedRiskAssessmentModalButtonProps):JSX.Element
{
    const [show, setShow] = React.useState<boolean>(false);
    const [likelihood, setLikelihood] = React.useState<ActionPlanRiskLikelihood>(props.likelihood);
    const [consequence, setConsequence] = React.useState<ActionPlanRiskConsequence>(props.consequence);
    const [didChange, setDidChange] = React.useState<boolean>(false);

    React.useEffect(() => {
        setLikelihood(props.likelihood);
        setConsequence(props.consequence);
    }, [props.likelihood, props.consequence]);

    function handleShow()
    {
        setShow(true);
        setDidChange(false);
    }

    function handleChange(consequence: ActionPlanRiskConsequence, likelihood: ActionPlanRiskLikelihood)
    {
        setLikelihood(likelihood);
        setConsequence(consequence);
        setDidChange(true);
    }

    return (
        <>
            <Button variant="text" size="32px" icon="interface_actions_edit" toolTipText="Anvend detaljeret risikovurdering"
                onClick={handleShow} />

            <Modal
                showModal={show}
                title="Risikovurdering"
                onCancel={() => setShow(false)}
                content={
                    <Flex flexDirection="column" gap={16}>
                        
                        <div style={{minHeight:'850px'}}>
                            <DetailedRiskAssessmentEvaluator
                                likelihood={likelihood} 
                                consequence={consequence} 
                                onChange={handleChange} />
                        </div>
                    
                        <Flex gap={8} justifyContent="flex-end">
                            <Button variant="filled" text="Opdater vurdering"
                                disabled={!didChange}
                                onClick={() => {
                                    props.onUpdate(consequence, likelihood);
                                    setShow(false);
                                }} />
                            
                            <Button variant="outlined" text="Annullér"
                                onClick={() => {
                                    setLikelihood(props.likelihood);
                                    setConsequence(props.consequence);
                                    setShow(false)
                                }} />
                        </Flex>
                    </Flex>
                }
            />
        </>
    );
}